module.exports = __webpack_public_path__ + "img/uploaded.5c7e5ba2.svg";